"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainCard = void 0;
const react_1 = __importDefault(require("react"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const HorizontalStack_1 = __importDefault(require("@mdigital/components/dist/components/HorizontalStack"));
const modals_1 = require("@mdigital/components/dist/utils/modals");
const EmptyDomainPage_1 = require("./EmptyDomainPage");
const DomainTable_1 = require("./DomainTable");
const AddDomain_1 = require("./Modals/AddDomain");
const EditDomain_1 = require("./Modals/EditDomain");
const utils_1 = require("../../../common/utils");
const styled_1 = require("./styled");
const TextPathPrefix = 'app.pages.administration.domainsList';
const AddDomainTitle = `${TextPathPrefix}.addDomain`;
const PredefinedDomains = `${TextPathPrefix}.predefinedDomainsTitle`;
const SearchResults = `${TextPathPrefix}.searchResults`;
const TotalDomainsNumber = `${TextPathPrefix}.totalDomainsNumber`;
const Search = `${TextPathPrefix}.search`;
const ActionBlock = (props) => (react_1.default.createElement(HorizontalStack_1.default, { gap: (0, alchemy_ui_1.units)(2), alignItems: 'center' },
    react_1.default.createElement(alchemy_ui_1.SearchField, { onChange: props.filterDomain, inputProps: { placeholder: (0, utils_1.getSingleText)(Search) }, value: props.searchedValue, style: { width: 300 } }),
    react_1.default.createElement(alchemy_ui_1.Button, { onClick: props.addNewDomain }, (0, utils_1.getSingleText)(AddDomainTitle))));
const DomainCard = (props) => {
    const { domains, filterDomain, removeItem, updateDomain, addDomain, totalDomainsCount, searchedValue } = props;
    const addNewDomain = () => {
        modals_1.ModalsService.showCustomModal(AddDomain_1.AddDomain, {
            domains: props.domains.map((item) => item.domainName),
            onSubmit: (item) => {
                props.addDomain(item);
            },
        });
    };
    const editDomain = (data) => {
        modals_1.ModalsService.showCustomModal(EditDomain_1.EditDomain, {
            data: data,
            domainNames: props.domains.filter((item) => item !== data).map((item) => item.domainName),
            onSubmit: (item, val) => {
                updateDomain(item, val);
            },
            closeModal: () => modals_1.ModalsService.closeModals(),
            render: (props) => (react_1.default.createElement(EditDomain_1.EditDomain, Object.assign({}, props, props))),
        });
    };
    const areDomainsFiltered = !!searchedValue.trim().length;
    const SearchResultsText = (0, utils_1.getSingleText)(SearchResults).replace('{{domains}}', domains.length.toString()).replace('{{totalDomains}}', totalDomainsCount.toString());
    const TotalDomainsNumberText = (0, utils_1.getSingleText)(TotalDomainsNumber).replace('{{totalDomainsCount}}', totalDomainsCount.toString());
    return (react_1.default.createElement(styled_1.FullHeightCard, null,
        react_1.default.createElement(alchemy_ui_1.CardHeader, { title: (0, utils_1.getSingleText)(PredefinedDomains), subtitle: areDomainsFiltered ? SearchResultsText : TotalDomainsNumberText, endItems: react_1.default.createElement(ActionBlock, { addNewDomain: addNewDomain, filterDomain: filterDomain, searchedValue: searchedValue }) }),
        react_1.default.createElement(alchemy_ui_1.CardBody, null, totalDomainsCount ?
            react_1.default.createElement(DomainTable_1.DomainTable, { domains: domains, removeItem: removeItem, editDomain: editDomain }) :
            react_1.default.createElement(EmptyDomainPage_1.EmptyDomainPage, { domains: domains, addNewDomain: addDomain }))));
};
exports.DomainCard = DomainCard;
